(function () {
  var solagVariantScriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : '';

  function compactSolagSizeGuide(root) {
    var scope = root || document;
    var tables = scope.querySelectorAll('.solag-size-guide__table');
    if (!tables.length) return;

    if (!document.querySelector('style[data-solag-size-guide-fix]')) {
      var style = document.createElement('style');
      style.setAttribute('data-solag-size-guide-fix', 'true');
      style.textContent = [
        '.solag-size-guide__header{background:radial-gradient(circle at 20% 24%,rgba(87,99,121,.52),transparent 32%),radial-gradient(circle at 94% 94%,rgba(93,38,39,.34),transparent 38%),linear-gradient(145deg,#2b3342 0%,#232b39 44%,#171d27 74%,#111722 100%)!important}',
        '.solag-size-guide__header p{color:rgba(255,255,255,.76)!important}',
        '.solag-size-guide__header h3{font-size:clamp(17px,1.45vw,22px)!important;line-height:1.08!important}',
        '.solag-size-guide__method{border-left-color:rgba(245,158,11,.28)!important}',
        '.solag-size-guide__method strong{font-size:13px!important}',
        '.solag-size-guide__method li{color:rgba(255,255,255,.87)!important}',
        '.solag-size-guide__method li span{background:#f59e0b!important;color:#111418!important}',
        '.solag-size-guide__table{table-layout:fixed!important}',
        '.solag-size-guide__metric-col{width:15%!important}',
        '.solag-size-guide__size-col{width:12.142%!important}',
        '.solag-size-guide__brand{min-width:0!important}',
        '.solag-size-guide__measure-visual{width:min(100%,138px)!important;margin-top:10px!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;overflow:visible!important}',
        '.solag-size-guide__measure-visual img{display:block!important;width:100%!important;height:auto!important;object-fit:contain!important;image-rendering:auto!important}',
        '.solag-size-guide__table tbody th{text-align:center!important;white-space:normal!important;overflow-wrap:normal!important;line-height:1.1!important;width:15%!important}',
        '.solag-size-guide__metric-name{display:block!important;margin:0!important;padding:0!important;border-radius:0!important;background:transparent!important;color:#151a20!important;font-size:10.5px!important;line-height:1.05!important;letter-spacing:0!important}',
        '.solag-size-guide__unit{display:inline-block!important;margin:3px 0 0!important;border-radius:999px!important;padding:2px 6px!important;background:#111418!important;color:#fff!important;font-size:10px!important;line-height:1!important;letter-spacing:.04em!important}',
        '@media(max-width:749px){.solag-size-guide__header{grid-template-columns:minmax(0,.74fr) minmax(0,1.26fr)!important;padding:16px!important}.solag-size-guide__measure-visual{width:min(100%,128px)!important;margin-top:10px!important}.solag-size-guide__method{border-left:1px solid rgba(245,158,11,.28)!important;border-top:0!important;padding-left:12px!important;padding-top:0!important}.solag-size-guide__table{min-width:680px!important;table-layout:fixed!important}}',
        '@media(max-width:420px){.solag-size-guide__header{grid-template-columns:1fr!important;gap:16px!important;padding:20px 16px 18px!important}.solag-size-guide__measure-visual{width:min(48vw,168px)!important;margin-top:12px!important}.solag-size-guide__method{border-left:0!important;border-top:1px solid rgba(245,158,11,.28)!important;padding-left:0!important;padding-top:12px!important}}'
      ].join('');
      document.head.appendChild(style);
    }

    function themeAssetUrl(filename) {
      var scriptSrc = solagVariantScriptSrc;
      if (!scriptSrc) {
        var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src*="solag-variant-images.js"]'));
        scriptSrc = scripts.length ? scripts[scripts.length - 1].src : '';
      }
      if (scriptSrc) return scriptSrc.replace(/assets\/solag-variant-images\.js.*/, 'assets/' + filename);
      return '/cdn/shop/files/' + filename;
    }

    function measurementDiagramHtml() {
      return [
        '<div class="solag-size-guide__measure-visual" role="img" aria-label="Hand measurement diagram showing length and palm circumference">',
        '<img src="' + themeAssetUrl('solag-measurement-method-clean-2x.png') + '" alt="Hand measurement diagram showing length and palm circumference" width="586" height="594" loading="lazy">',
        '</div>'
      ].join('');
    }

    function setHeader(th, metricLabel, unit, ariaLabel) {
      th.setAttribute('aria-label', ariaLabel + ' ' + unit);
      th.innerHTML = '<span class="solag-size-guide__metric-name">Palm<br>' + metricLabel + '</span><span class="solag-size-guide__unit">' + unit + '</span>';
    }

    Array.prototype.slice.call(tables).forEach(function (table) {
      var guide = table.closest ? table.closest('.solag-size-guide') : null;
      var header = guide ? guide.querySelector('.solag-size-guide__header') : null;
      var brand = header ? header.querySelector('.solag-size-guide__brand, div:first-child') : null;
      if (brand) {
        brand.classList.add('solag-size-guide__brand');
        if (!brand.querySelector('.solag-size-guide__measure-visual')) {
          brand.insertAdjacentHTML('beforeend', measurementDiagramHtml());
        }
        var measurementImage = brand.querySelector('.solag-size-guide__measure-visual img');
        if (measurementImage && measurementImage.src.indexOf('solag-measurement-method-original.png') !== -1) {
          measurementImage.src = themeAssetUrl('solag-measurement-method-clean-2x.png');
          measurementImage.width = 586;
          measurementImage.height = 594;
        }
      }

      if (!table.querySelector('colgroup')) {
        var colgroup = document.createElement('colgroup');
        var metricCol = document.createElement('col');
        var sizeCol = document.createElement('col');
        metricCol.className = 'solag-size-guide__metric-col';
        sizeCol.className = 'solag-size-guide__size-col';
        sizeCol.setAttribute('span', '7');
        colgroup.appendChild(metricCol);
        colgroup.appendChild(sizeCol);

        var caption = table.querySelector('caption');
        if (caption && caption.parentNode === table && caption.nextSibling) {
          table.insertBefore(colgroup, caption.nextSibling);
        } else if (caption && caption.parentNode === table) {
          table.appendChild(colgroup);
        } else {
          table.insertBefore(colgroup, table.firstChild);
        }
      }

      var firstHead = table.querySelector('thead th:first-child');
      if (firstHead) {
        firstHead.setAttribute('aria-label', 'Adult Size');
        firstHead.textContent = 'Size';
      }

      Array.prototype.slice.call(table.querySelectorAll('tbody th')).forEach(function (th) {
        var text = th.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        var unit = text.indexOf(' cm') !== -1 || /cm$/.test(text) ? 'CM' : 'IN';
        if (text.indexOf('circumference') !== -1 || text.indexOf('circ.') !== -1) {
          setHeader(th, 'Circ.', unit, 'Palm Circumference');
        } else if (text.indexOf('length') !== -1) {
          setHeader(th, 'Length', unit, 'Palm Length');
        }
      });
    });
  }

  function initSolagVariantImages() {
    var section = document.querySelector('.solag-product');
    if (!section || document.documentElement.dataset.solagVariantImages === 'ready') return;

    document.documentElement.dataset.solagVariantImages = 'ready';
    compactSolagSizeGuide(section);

    var gallery = section.querySelector('.solag-product__gallery');
    var thumbs = section.querySelector('.solag-product__thumbs');
    var main = section.querySelector('.solag-product__main-media');
    var activeColor = '';
    if (!gallery || !thumbs || !main) return;

    if (!document.querySelector('style[data-solag-variant-images]')) {
      var style = document.createElement('style');
      style.setAttribute('data-solag-variant-images', 'true');
      style.textContent = [
        '.solag-product__thumbs{display:grid!important;gap:12px!important;align-content:start!important;max-height:640px!important;overflow-y:auto!important;padding:2px 4px 2px 2px!important;scrollbar-width:thin}',
        '.solag-product__thumb{flex:0 0 auto}',
        '.solag-product__thumb.is-active{border-color:#111418!important;box-shadow:0 0 0 2px #111418!important}',
        '#shopify-pc__banner,.shopify-pc__banner__dialog,.shopify-pc__prefs__dialog{display:none!important;visibility:hidden!important;pointer-events:none!important}',
        '.solag-related-fallback{background:#fff;padding:44px 0 32px}.solag-related-fallback__inner{max-width:1200px;margin:0 auto;padding:0 20px}.solag-related-fallback h2{margin:0 0 22px;color:#111418;font-family:Inter,"Helvetica Neue",Arial,sans-serif;font-size:clamp(24px,2vw,32px);font-weight:800;letter-spacing:0}.solag-related-fallback product-recommendations{display:block}.solag-related-fallback .product-grid{margin-top:0}.solag-related-fallback__empty{color:#5a626d;font-size:14px}',
        '@media(max-width:860px){.solag-product__gallery{display:flex!important;flex-direction:column-reverse!important}.solag-product__thumbs{display:flex!important;gap:10px!important;max-height:none!important;overflow-x:auto!important;overflow-y:hidden!important;padding:2px 2px 10px!important;margin-top:12px!important;scroll-snap-type:x proximity!important;-webkit-overflow-scrolling:touch}.solag-product__thumb{flex:0 0 72px!important;width:72px!important;scroll-snap-align:start!important}}'
      ].join('');
      document.head.appendChild(style);
    }

    function sized(url, width) {
      if (!url) return '';
      try {
        var parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', width);
        return parsed.toString();
      } catch (error) {
        return String(url);
      }
    }

    function imageKey(url) {
      if (!url) return '';
      try {
        return new URL(url, window.location.origin).pathname.split('/').pop().toLowerCase();
      } catch (error) {
        return String(url).split('?')[0].split('/').pop().toLowerCase();
      }
    }

    function normalizeColor(value) {
      return String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
    }

    function colorFromOptionValue(value) {
      var normalized = normalizeColor(value);
      if (normalized.indexOf('army green') !== -1) return 'army green';
      if (normalized.indexOf('coyote') !== -1) return 'coyote';
      if (normalized.indexOf('black') !== -1) return 'black';
      if (normalized.indexOf('grey') !== -1) return 'grey';
      if (normalized.indexOf('gray') !== -1) return 'grey';
      return normalized;
    }

    function colorTagFrom(text) {
      var match = String(text || '').match(/\bcolor\s*:\s*([^,;|\n\r]+)/i);

      // Untagged media is treated as shared content until color tags are added.
      return match ? normalizeColor(match[1]) : 'all';
    }

    function parseJson(selector, fallback) {
      try {
        var node = section.querySelector(selector);
        return node ? JSON.parse(node.textContent) : fallback;
      } catch (error) {
        return fallback;
      }
    }

    function currentOptions() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-solag-option-index]')).map(function (group) {
        var checked = group.querySelector('[data-solag-option]:checked');
        return checked ? checked.value : '';
      });
    }

    function currentColor() {
      var colorGroup = Array.prototype.slice.call(section.querySelectorAll('[data-solag-option-index]')).find(function (group) {
        var name = normalizeColor(group.dataset.solagOptionName);
        if (name.indexOf('style') !== -1) {
          var selected = group.querySelector('[data-solag-option]:checked');
          return selected && colorFromOptionValue(selected.value) !== normalizeColor(selected.value);
        }
        return name === 'color' || name === 'colour' || name === '颜色';
      });
      var checked = colorGroup ? colorGroup.querySelector('[data-solag-option]:checked') : null;
      return checked ? colorFromOptionValue(checked.value) : '';
    }

    function buttonMatchesColor(button, color) {
      var normalizedColor = normalizeColor(color);
      var mediaColor = colorTagFrom(button.dataset.colorTags || button.dataset.mediaAlt || '');
      return !normalizedColor || mediaColor === 'all' || mediaColor === normalizedColor;
    }

    function setButtonVisibility(button, isVisible) {
      button.hidden = !isVisible;
      button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    function syncThumb(src) {
      var target = imageKey(src);
      var matched = false;
      section.querySelectorAll('[data-solag-media-button]').forEach(function (button) {
        var image = button.querySelector('img');
        var source = button.dataset.mediaSrc || (image ? image.src : '');
        var isMatch = target && imageKey(source) === target;
        button.classList.toggle('is-active', isMatch);
        if (isMatch) {
          matched = true;
          if (typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      });
      if (!matched) {
        section.querySelectorAll('[data-solag-media-button]').forEach(function (button) {
          button.classList.remove('is-active');
        });
      }
    }

    function setMain(src, alt) {
      if (!src) return;
      main.src = sized(src, 1200);
      main.srcset = [500, 700, 900, 1200].map(function (width) {
        return sized(src, width) + ' ' + width + 'w';
      }).join(', ');
      if (alt) main.alt = alt;
      syncThumb(src);
    }

    function filterThumbsByColor(color, preferredMedia) {
      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-solag-media-button]'));
      if (!buttons.length) return;

      var visibleButtons = buttons.filter(function (button) {
        return buttonMatchesColor(button, color);
      });
      if (!visibleButtons.length) visibleButtons = buttons;

      buttons.forEach(function (button) {
        setButtonVisibility(button, visibleButtons.includes(button));
      });

      var preferredKey = preferredMedia && preferredMedia.src ? imageKey(preferredMedia.src) : '';
      var preferredButton = preferredKey ? visibleButtons.find(function (button) {
        return imageKey(button.dataset.mediaSrc || '') === preferredKey;
      }) : null;
      var activeButton = visibleButtons.find(function (button) {
        return button.classList.contains('is-active');
      });
      var targetButton = preferredButton || activeButton || visibleButtons[0];
      var image = targetButton ? targetButton.querySelector('img') : null;

      if (targetButton) {
        setMain(
          targetButton.dataset.mediaSrc || (image ? image.src : ''),
          targetButton.dataset.mediaAlt || (image ? image.alt : '')
        );
      }
    }

    function bindThumb(button) {
      if (button.dataset.solagBound === 'true') return;
      button.dataset.solagBound = 'true';
      button.addEventListener('click', function () {
        if (button.hidden) return;
        var image = button.querySelector('img');
        var src = button.dataset.mediaSrc || (image ? image.src : '');
        setMain(src, button.dataset.mediaAlt || (image ? image.alt : ''));
      });
    }

    function ensureThumb(src, alt) {
      if (!src) return;
      var target = imageKey(src);
      var exists = false;
      section.querySelectorAll('[data-solag-media-button]').forEach(function (button) {
        var image = button.querySelector('img');
        var source = button.dataset.mediaSrc || (image ? image.src : '');
        if (imageKey(source) === target) exists = true;
      });
      if (exists) return;

      var button = document.createElement('button');
      button.className = 'solag-product__thumb';
      button.type = 'button';
      button.setAttribute('data-solag-media-button', '');
      button.dataset.mediaSrc = sized(src, 1200);
      button.dataset.mediaAlt = alt || main.alt || 'Product image';
      button.dataset.colorTags = alt || '';
      button.setAttribute('aria-label', 'View product image');

      var img = document.createElement('img');
      img.src = sized(src, 160);
      img.alt = button.dataset.mediaAlt;
      img.loading = 'lazy';
      img.width = 160;
      img.height = 160;
      button.appendChild(img);
      thumbs.appendChild(button);
      bindThumb(button);
    }

    function findVariantMedia(selected, productData, inlineMedia) {
      var match = null;
      if (productData && Array.isArray(productData.variants)) {
        match = productData.variants.find(function (variant) {
          return Array.isArray(variant.options) && variant.options.every(function (option, index) {
            return option === selected[index];
          });
        });
        if (match && match.featured_image && match.featured_image.src) {
          return { src: match.featured_image.src, alt: match.featured_image.alt || main.alt || '' };
        }
      }

      if (Array.isArray(inlineMedia)) {
        match = inlineMedia.find(function (item) {
          return Array.isArray(item.options) && item.options.every(function (option, index) {
            return option === selected[index];
          });
        });
        if (match && match.image && match.image.src) {
          return { src: match.image.src, alt: match.image.alt || main.alt || '' };
        }
      }

      return null;
    }

    function syncProductCopy(productData) {
      if (!productData) return;

      var freshSummary = section.getAttribute('data-tactical-summary') || '';
      var title = section.getAttribute('data-tactical-title') || productData.title || 'Seibertron tactical gloves';
      var titleNode = section.querySelector('h1');
      var breadcrumbCurrent = section.querySelector('.solag-product__breadcrumb span:last-child');
      var summaryNode = section.querySelector('.solag-product__summary');
      var detailsNode = section.querySelector('.solag-product__description .rte');

      if (titleNode) titleNode.textContent = title;
      if (breadcrumbCurrent) breadcrumbCurrent.textContent = title;
      if (summaryNode && freshSummary) summaryNode.textContent = freshSummary;
      if (detailsNode && productData.description && detailsNode.dataset.tacticalStaticDescription !== 'true') detailsNode.innerHTML = productData.description;

      if (document.title) document.title = title;
    }

    function ensureRelatedProducts(productData) {
      if (!productData || !productData.id) return;
      if (document.querySelector('product-recommendations, .solag-related-fallback')) return;

      var related = document.createElement('section');
      related.className = 'solag-related-fallback';
      related.innerHTML = [
        '<div class="solag-related-fallback__inner">',
        '<h2>FREQUENTLY BOUGHT TOGETHER</h2>',
        '<product-recommendations class="product-recommendations"><p class="solag-related-fallback__empty">Loading recommendations...</p></product-recommendations>',
        '</div>'
      ].join('');

      var judgeSection = document.querySelector('[id*="judgeme"], .jdgm-widget, .shopify-app-block');
      if (judgeSection) {
        var parentSection = judgeSection.closest('.shopify-section') || judgeSection;
        parentSection.insertAdjacentElement('afterend', related);
      } else {
        section.insertAdjacentElement('afterend', related);
      }

      var target = related.querySelector('product-recommendations');
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var url = root + 'recommendations/products?section_id=product-recommendations&product_id=' + productData.id + '&limit=4';

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var grid = html.querySelector('ul.product-grid');
          if (grid) {
            target.innerHTML = grid.outerHTML;
            target.classList.add('product-recommendations--loaded');
          } else {
            target.innerHTML = '<p class="solag-related-fallback__empty">No related products available.</p>';
          }
        })
        .catch(function () {
          target.innerHTML = '<p class="solag-related-fallback__empty">No related products available.</p>';
        });
    }

    function apply(productData) {
      var inlineMedia = parseJson('[data-solag-variant-media]', []);

      syncProductCopy(productData);

      if (productData && Array.isArray(productData.images)) {
        productData.images.forEach(function (src) {
          ensureThumb(src, main.alt || 'Product image');
        });
      }

      inlineMedia.forEach(function (item) {
        if (item && item.image && item.image.src) {
          ensureThumb(item.image.src, item.image.alt || main.alt || 'Product image');
        }
      });

      section.querySelectorAll('[data-solag-media-button]').forEach(bindThumb);

      function updateFromSelection() {
        section.querySelectorAll('[data-solag-option-index]').forEach(function (group) {
          var checked = group.querySelector('[data-solag-option]:checked');
          var selected = group.querySelector('[data-solag-selected-option]');
          if (selected && checked) selected.textContent = checked.value;
          group.querySelectorAll('.solag-product__choice').forEach(function (choice) {
            choice.classList.remove('is-selected');
          });
          if (checked) {
            var label = checked.closest('.solag-product__choice');
            if (label) label.classList.add('is-selected');
          }
        });

        var media = findVariantMedia(currentOptions(), productData, inlineMedia);
        var nextColor = normalizeColor(currentColor());
        var colorChanged = nextColor && nextColor !== activeColor;
        filterThumbsByColor(nextColor, colorChanged || !nextColor ? media : null);
        activeColor = nextColor;
      }

      section.addEventListener('change', function (event) {
        if (event.target && event.target.matches('[data-solag-option]')) {
          setTimeout(updateFromSelection, 0);
        }
      });

      if (section.dataset.solagChoiceClickBound !== 'true') {
        section.dataset.solagChoiceClickBound = 'true';
        section.addEventListener('click', function (event) {
          var label = event.target && event.target.closest ? event.target.closest('.solag-product__choice') : null;
          if (!label || !section.contains(label)) return;
          var input = label.querySelector('[data-solag-option]');
          if (!input) return;
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            setTimeout(updateFromSelection, 0);
          }
        });
      }

      updateFromSelection();

      ensureRelatedProducts(productData);
    }

    apply(null);

    fetch(window.location.pathname + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (productData) {
        if (productData) apply(productData);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSolagVariantImages);
  } else {
    initSolagVariantImages();
  }
})();

(function () {
  function returnAssetUrl(filename) {
    var scriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : "";
    if (!scriptSrc) {
      var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src*="solag-variant-images.js"]'));
      scriptSrc = scripts.length ? scripts[scripts.length - 1].src : "";
    }
    return scriptSrc ? scriptSrc.replace(/assets\/solag-variant-images\.js.*/, "assets/" + filename) : "/cdn/shop/files/" + filename;
  }

  function cleanSeibertronReturnContact() {
    if (window.location.pathname !== "/pages/return") return;

    document.querySelectorAll(".seibertron-return__contact, .seibertron-return-fallback__contact, .seibertron-return-client__contact").forEach(function (element) {
      element.remove();
    });

    document.querySelectorAll(".seibertron-return__button--primary, .seibertron-return-fallback__button--primary, .seibertron-return-client__button--primary").forEach(function (link) {
      if (/start a return/i.test(link.textContent || "")) {
        link.setAttribute("href", "/pages/contact");
      }
    });
  }

  function initSeibertronReturnClientFallback() {
    if (window.location.pathname !== "/pages/return") return;
    cleanSeibertronReturnContact();
    if (document.querySelector("[data-native-return-policy]")) return;
    var main = document.getElementById("MainContent");
    if (!main) return;

    var returnImage = returnAssetUrl("seibertron-home-banner-returns-20260630.png");
    main.innerHTML = [
      '<style data-seibertron-return-client-fallback>',
      '.seibertron-return-client{--return-ink:#101418;--return-muted:#5d6673;--return-line:#e6e8ec;--return-blue:#0f6bff;--return-yellow:#f6c800;background:#fff;color:var(--return-ink);font-family:Inter,"Helvetica Neue",Arial,sans-serif}.seibertron-return-client *{box-sizing:border-box;letter-spacing:0}.seibertron-return-client a{color:inherit;text-decoration:none}.seibertron-return-client__wrap{width:min(1240px,calc(100% - 40px));margin:0 auto}.seibertron-return-client__hero{display:grid;grid-template-columns:minmax(0,.9fr) minmax(420px,1.1fr);gap:28px;align-items:stretch;padding:46px 0 34px}.seibertron-return-client__copy{display:flex;min-height:430px;flex-direction:column;justify-content:center;border:1px solid var(--return-line);border-radius:8px;background:radial-gradient(circle at 15% 15%,rgba(246,200,0,.22),transparent 31%),linear-gradient(145deg,#fff 0%,#f7f8fb 100%);padding:clamp(30px,5vw,62px)}.seibertron-return-client__eyebrow{width:fit-content;margin:0 0 18px;border:1px solid rgba(16,20,24,.16);border-radius:999px;padding:8px 14px;color:var(--return-muted);font-size:12px;font-weight:800;text-transform:uppercase}.seibertron-return-client h1,.seibertron-return-client h2,.seibertron-return-client h3,.seibertron-return-client p{margin:0}.seibertron-return-client h1{max-width:580px;color:var(--return-ink);font-size:clamp(42px,5vw,78px);font-weight:850;line-height:.98}.seibertron-return-client__lead{max-width:610px;margin-top:22px;color:#303843;font-size:clamp(17px,1.4vw,21px);line-height:1.52}.seibertron-return-client__actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:30px}.seibertron-return-client__button{display:inline-flex;min-height:48px;align-items:center;justify-content:center;border-radius:999px;padding:0 22px;font-size:15px;font-weight:850;line-height:1}.seibertron-return-client__button--primary{background:var(--return-ink);color:#fff;box-shadow:0 14px 26px rgba(16,20,24,.18)}.seibertron-return-client__button--secondary{border:1px solid rgba(16,20,24,.18);background:#fff;color:var(--return-ink)}.seibertron-return-client__media{min-height:430px;margin:0;overflow:hidden;border-radius:8px;background:#dde1e7;box-shadow:0 18px 38px rgba(16,20,24,.12)}.seibertron-return-client__media img{display:block;width:100%;height:100%;min-height:430px;object-fit:cover;object-position:70% 50%}.seibertron-return-client__cards{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;padding:0 0 42px}.seibertron-return-client__card{min-height:150px;border:1px solid var(--return-line);border-radius:8px;background:#fff;padding:24px}.seibertron-return-client__card strong{display:block;color:var(--return-ink);font-size:clamp(24px,2.1vw,34px);font-weight:850;line-height:1}.seibertron-return-client__card span{display:block;margin-top:12px;color:var(--return-muted);font-size:15px;line-height:1.55}.seibertron-return-client__band{border-top:1px solid var(--return-line);border-bottom:1px solid var(--return-line);background:#f4f6f8;padding:clamp(44px,6vw,78px) 0}.seibertron-return-client__band h2,.seibertron-return-client__support h2{color:var(--return-ink);font-size:clamp(32px,4vw,56px);font-weight:850;line-height:1}.seibertron-return-client__steps,.seibertron-return-client__details{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:14px;margin-top:28px}.seibertron-return-client__step,.seibertron-return-client__detail{border:1px solid var(--return-line);border-radius:8px;background:#fff;padding:24px}.seibertron-return-client__num{display:inline-flex;width:38px;height:38px;align-items:center;justify-content:center;border-radius:50%;background:var(--return-yellow);color:var(--return-ink);font-size:15px;font-weight:900}.seibertron-return-client__step h3,.seibertron-return-client__detail h3{margin-top:18px;color:var(--return-ink);font-size:21px;font-weight:850;line-height:1.14}.seibertron-return-client__step p,.seibertron-return-client__detail p,.seibertron-return-client__support p{margin-top:12px;color:var(--return-muted);font-size:15px;line-height:1.58}.seibertron-return-client__support{padding:clamp(44px,6vw,78px) 0}.seibertron-return-client__support-box{display:grid;grid-template-columns:1fr;gap:24px;align-items:center;border:1px solid rgba(15,107,255,.16);border-radius:8px;background:linear-gradient(90deg,rgba(15,107,255,.08),rgba(246,200,0,.16)),#fff;padding:clamp(28px,4vw,44px)}@media(max-width:989px){.seibertron-return-client__hero,.seibertron-return-client__support-box{grid-template-columns:1fr}.seibertron-return-client__cards,.seibertron-return-client__steps,.seibertron-return-client__details{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:640px){.seibertron-return-client__wrap{width:min(100% - 28px,1240px)}.seibertron-return-client__copy{min-height:auto;padding:28px 22px}.seibertron-return-client__media,.seibertron-return-client__media img{min-height:260px}.seibertron-return-client__cards,.seibertron-return-client__steps,.seibertron-return-client__details{grid-template-columns:1fr}.seibertron-return-client__button{width:100%}}',
      '</style>',
      '<section class="seibertron-return-client" data-native-return-policy data-seibertron-return-client-fallback>',
      '<div class="seibertron-return-client__wrap"><div class="seibertron-return-client__hero"><div class="seibertron-return-client__copy"><p class="seibertron-return-client__eyebrow">Return Policy</p><h1>Easy, hassle-free returns</h1><p class="seibertron-return-client__lead">Not completely satisfied? Contact Seibertron support first so we can confirm eligibility, the correct return address, and the fastest next step.</p><div class="seibertron-return-client__actions"><a class="seibertron-return-client__button seibertron-return-client__button--primary" href="/pages/contact">Start a return</a><a class="seibertron-return-client__button seibertron-return-client__button--secondary" href="/collections/all">Shop replacement gear</a></div></div><figure class="seibertron-return-client__media"><img src="' + returnImage + '" alt="Customer preparing a Seibertron return shipment" width="2170" height="725" loading="eager"></figure></div>',
      '<div class="seibertron-return-client__cards"><div class="seibertron-return-client__card"><strong>30 days</strong><span>Eligible items may be returned within 30 days when new, unworn, unwashed, and complete with original tags and packaging.</span></div><div class="seibertron-return-client__card"><strong>Contact first</strong><span>Please request authorization before shipping anything back. We will provide the right return address for your location.</span></div><div class="seibertron-return-client__card"><strong>1-2 days</strong><span>After inspection, approved refunds are processed to the original payment method within 1-2 business days.</span></div></div></div>',
      '<div class="seibertron-return-client__band"><div class="seibertron-return-client__wrap"><h2>How to return your order</h2><div class="seibertron-return-client__steps"><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">1</span><h3>Request authorization</h3><p>Email our team with your order number, proof of purchase, photos, and reason for return.</p></article><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">2</span><h3>Pack the item</h3><p>Return the product in original packaging with tags attached and proof of purchase inside.</p></article><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">3</span><h3>Ship with tracking</h3><p>Use a trackable shipping method and keep your receipt until the return is resolved.</p></article><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">4</span><h3>Inspection and refund</h3><p>Approved refunds are issued after inspection. For exchanges, return the item and place a new order.</p></article></div></div></div>',
      '<div class="seibertron-return-client__wrap seibertron-return-client__support"><h2>Policy details</h2><div class="seibertron-return-client__details"><article class="seibertron-return-client__detail"><h3>Return freight</h3><p>Customers are responsible for return freight unless support confirms otherwise.</p></article><article class="seibertron-return-client__detail"><h3>Refused returns</h3><p>Used, washed, damaged, missing-tag, or unsaleable items may be refused.</p></article><article class="seibertron-return-client__detail"><h3>Warranty review</h3><p>For defects, contact us with photos and proof of purchase so we can review repair or replacement options.</p></article><article class="seibertron-return-client__detail"><h3>Exclusions</h3><p>Coverage excludes non-authorized purchases, misuse, abuse, tampering, customer modification, or caustic exposure.</p></article></div></div>',
      '<div class="seibertron-return-client__wrap seibertron-return-client__support"><div class="seibertron-return-client__support-box"><div><h2>Need help with a return?</h2><p>Send your order number, proof of purchase, product photos, and a short description of the issue.</p></div></div></div>',
      '</section>'
    ].join("");
    cleanSeibertronReturnContact();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSeibertronReturnClientFallback);
  } else {
    initSeibertronReturnClientFallback();
  }
})();
